import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var f = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-722 -224)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M0.001 1.73907H0V18.2609H0.001V10V1.73907Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000305176H0V19.9999H20V0.000305176Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000305176H0V4.00032H20V0.000305176Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 7.99994H0V12H20V7.99994Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 16H0V20H20V16Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10 10.0003L0 20V0L10 10.0003Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M3.26168 7.62231L3.8518 9.43857H5.76173L4.21665 10.5612L4.80677 12.3776L3.26168 11.255L1.71656 12.3776L2.3068 10.5612L0.761719 9.43857H2.67157L3.26168 7.62231Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  f as default
};
